export default {
  production: '656457a64b5f745125cc515b',
  development: '655aa4d4ca78a7506c2c6283',
};
